import React from "react"
import { Button, notification } from "antd"

import i18n from "Shared/locales/i18n"
import * as HttpStatus from "http-status"
import { extractErrors } from "Shared/utils"
import { ErrorInterface } from "Shared/utils/errorHandler"
import { getAccessTokenValidTime } from "Shared/utils/auth.utils"

export enum NotificationTypeEnum {
    SUCCESS = "success",
    INFO = "info",
    WARNING = "warning",
    ERROR = "error",
}

const NotificationService = {
    send: (
        type: NotificationTypeEnum,
        message: string | React.ReactNode,
        description: string | React.ReactNode,
        duration: number = 3,
        key?: string,
        btn?: any,
        onClose?: () => void
    ) => {
        notification[type]({
            message,
            description,
            duration,
            className: "max-w-full ml-10 max-h-400 overflow-auto",
            key: key || type,
            btn,
            onClose,
        })
    },
    showLogoutWarning: () => {
        const validTime = getAccessTokenValidTime()
        NotificationService.send(
            NotificationTypeEnum.WARNING,
            "Login invalidated",
            <>
                Wait until you are logged out after {validTime} secs or log out manually.
            </>,
            validTime,
            "Login invalidated",
        )
    },
    showErrorNotificationBasedOnResponseError: (error: ErrorInterface | any, title: string, message?: string) => {
        let description

        if (message) {
            description = message
        } else if (error && error.response) {
            if (error.response.status === HttpStatus.UNAUTHORIZED) return
            description = message || extractErrors(error.response)[0]
        } else {
            if (error.message === "Network Error") {
                description = i18n.t("error:unavailable")
            } else {
                if (error === "cancelled") {
                    description = i18n.t("error:unauthorized_action")
                } else if (error?.code === "ECONNABORTED") {
                    // axios request timeout triggered
                    description = i18n.t("error:timeout")
                } else {
                    description = i18n.t("error:unknown")
                }
            }
        }
        notification[NotificationTypeEnum.ERROR]({
            message: title,
            description: <span className="whitespace-pre-line">{description}</span>,
            duration: 10,
            className: "max-w-full ml-10",
        })
    },
    clear: () => notification.destroy(),
}

export default NotificationService
